export default "__VITE_ASSET__be2e2c90__"